<p *ngIf="showAlert && message !='' " [ngClass]="alertClass" style="position: relative;"  role="alert">
    <!-- Close icon -->
  <i class="fa fa-times bt" (click)="closeAlert()" style="cursor: pointer; position: absolute; right: 2px; "></i>
    <!-- Alert message -->
    {{ message }}  
  </p>
